var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "encrypted_2592317 1",
    clipPath: "url(#clip0_1588_12810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M94.3863 15.0807V47.1913C94.3863 55.1389 90.7436 64.3638 84.132 73.1669C76.4266 83.4232 65.0765 92.4763 51.3084 99.3476L49.9998 100L48.6911 99.3476C34.923 92.4763 23.573 83.4232 15.8676 73.1669C9.256 64.3638 5.61328 55.1389 5.61328 47.1913V15.0807L27.2079 0H72.7917L94.3863 15.0807Z",
    fill: "#00358F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M94.3865 15.0807V47.1913C94.3865 55.1389 90.7438 64.3638 84.1322 73.1669C76.4268 83.4232 65.0768 92.4763 51.3086 99.3476L50 100V0H72.7919L94.3865 15.0807Z",
    fill: "#012453"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M69.1036 11.7192H30.8951L17.332 21.1903V47.1913C17.332 56.1272 26.1234 73.5888 49.9993 86.7983C73.8753 73.5888 82.6666 56.1272 82.6666 47.1913V21.1903L69.1036 11.7192Z",
    fill: "#00B3FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M82.6673 21.1903V47.1913C82.6673 56.1272 73.8759 73.5888 50 86.7983V11.7192H69.1043L82.6673 21.1903Z",
    fill: "#0274F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M70.0256 8.78943H29.9733L14.4023 19.6629V47.1913C14.4023 52.9064 17.297 60.1684 22.3421 67.114C28.4849 75.5713 37.5575 83.265 48.5814 89.3629L49.9994 90.1481L51.4175 89.3629C62.4413 83.265 71.514 75.5713 77.6568 67.114C82.7019 60.1684 85.5965 52.9064 85.5965 47.1913V19.6629L70.0256 8.78943ZM79.7369 47.1913C79.7369 54.9865 71.7854 70.9032 49.9994 83.4349C28.2134 70.9032 20.2619 54.9865 20.2619 47.1913V22.7177L31.8171 14.649H68.1818L79.7369 22.7177V47.1913Z",
    fill: "#EFF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M85.5971 19.6629V47.1913C85.5971 52.9064 82.7024 60.1684 77.6573 67.114C71.5145 75.5713 62.4419 83.265 51.418 89.3629L50 90.1481V83.4349C71.786 70.9032 79.7375 54.9865 79.7375 47.1913V22.7177L68.1823 14.649H50V8.78943H70.0262L85.5971 19.6629Z",
    fill: "#C6E1EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M68.7036 34.0326L49.9998 53.256L49.9607 53.297L45.2046 58.1839L31.2959 45.1756L35.298 40.8961L45.0093 49.9805L49.9607 44.8943L49.9998 44.8533L64.5042 29.9465L68.7036 34.0326Z",
    fill: "#EFF5FA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M68.7039 34.0326L50 53.256V44.8533L64.5045 29.9465L68.7039 34.0326Z",
    fill: "#C6E1EC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1588_12810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafe);
export default __webpack_public_path__ + "static/media/safe.3f76ac73ad82c938d3da18a1a343b1d4.svg";
export { ForwardRef as ReactComponent };